import React, { useEffect, useMemo, useState } from "react";
import { apiClient } from "../../config/api";
import Loader from "../../common/Loader";
import "../PrathmikVibhag/PrathmikVibhag.css";
import { useNavigate } from "react-router-dom";
import { getNavodayaSubjectsByStandard } from "../../utils/subjectService";
import SectionDivider from "../../common/SectionDivider";

const Jawahar_Navodaya_Class_5 = ({ variant = "jawahar" }) => {
  const [fullData, setFullData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const variantKey = String(variant || "jawahar").toLowerCase();
  const isCet = variantKey === "cet";
  const isGnansetu8 = variantKey === "gnansetu8";

  const standardToShow = useMemo(() => {
    return isGnansetu8 ? 8 : 5;
  }, [isGnansetu8]);

  const subjectVariant = useMemo(() => {
    if (isGnansetu8) return "gnansetu8";
    if (isCet) return "cet";
    return "jawahar";
  }, [isGnansetu8, isCet]);

  const title = useMemo(() => {
    if (isGnansetu8) return "જ્ઞાનસેતુ (ધોરણ - 8)";
    return isCet ? "જ્ઞાનસેતુ - CET (ધોરણ - 5)" : "જવાહર નવોદય ક્લાસ 5";
  }, [isCet, isGnansetu8]);

  const subjectsRoute = useMemo(() => {
    if (isGnansetu8) return "/navodaya-vibhag/gnansadhna-class-8/subjects";
    return isCet
      ? "/navodaya-vibhag/gnansetu-cet-class-5/subjects"
      : "/navodaya-vibhag/jawahar-navodaya-class-5/subjects";
  }, [isCet, isGnansetu8]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiClient.get("/standard");
        setFullData(res.data);
      } catch (error) {
        console.error("Error fetching standards data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleCardClick = async (standard) => {
    try {
      // Use getSubjectsByStandard for Standard 5 (like PrathmikVibhag)
      const subjects = await getNavodayaSubjectsByStandard(
        standard.standard_index,
        subjectVariant
      );

      localStorage.setItem("subjectsData", JSON.stringify(subjects));
      localStorage.setItem("selectedStandard", JSON.stringify(standard));
      localStorage.setItem(
        "subjectsSource",
        isGnansetu8
          ? "gnansetu_std_8"
          : isCet
          ? "navodaya_class_5_cet"
          : "navodaya_class_5_jawahar"
      );

      navigate(subjectsRoute);
    } catch (e) {
      console.error(e);
    }
  };

  if (loading) return <Loader />;

  // Filter only Standard 5 data
  const filteredData = (fullData || []).filter((item) => {
    const index = Number(item.standard_index);
    return index === Number(standardToShow);
  });

  const colors = ["#4b34fa", "#0C9D26", "#F9B025", "#FD2D2B", "#D020CD"];

  return (
    <div className="pv-container">
      <SectionDivider title={title} />

      <div className="pv-row">
        {filteredData.map((item, index) => (
          <div
            key={item.id}
            className="pv-card-new"
            style={{ "--accent": colors[index % colors.length] }}
            onClick={() => handleCardClick(item)}
          >
            <div className="pv-card-top">
              <div className="pv-circle-outer">
                <div className="pv-circle-new">{item.standard_index}</div>
              </div>
            </div>

            <div className="pv-bottom-band">{item.standard_title}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Jawahar_Navodaya_Class_5;
